import { Helmet } from 'react-helmet';
import ParkingContainer from '../../../components/Parking/Main/ParkingContainer';
import ZoneForm from '../../../components/Parking/Zone/ZoneForm';
import { useParams } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

const Zone = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 925px)' });
    const params = useParams();
    return (
        <>
            <Helmet>
                <title>Select Zone | Level Parking</title>
            </Helmet>
            {isMobile ? (
                <ParkingContainer Component={<ZoneForm zoneID={params.zoneID} />} />
            ) : (
                <ZoneForm zoneID={params.zoneID} />
            )}
        </>
    );
};

export default Zone;
